import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Land cover analysis for the MPEW between 1997 and 2003 given in
              Fig. 4 illustrates that the vegetation cover has decreased from
              40.55% to 23.99% (Table 4). Vegetation cover along the corridor
              has reduced by ~10% i.e., from 33.9% to 23.99% during 2009 to
              2015.
            </p>
            <p style={{ textAlign: "center" }}>
              <img
                style={{ mixBlendMode: "multiply" }}
                src="images/gv4.png"
                alt=""
              />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.4</strong> Land Cover (NDVI) &ndash; Mumbai Pune
              Express corridor and buffer
            </p>
            <p>
              <strong>Table 4</strong> Land cover dynamics along the Mumbai-Pune
              corridor
            </p>
            <table align="center" width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="21%">
                    <p>Year</p>
                  </td>
                  <td style={styles.cell} width="31%">
                    <p>Vegetation (%)</p>
                  </td>
                  <td style={styles.cell} width="47%">
                    <p>Non-Vegetation (%)</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="21%">
                    <p>1997</p>
                  </td>
                  <td style={styles.cell} width="31%">
                    <p>40.55</p>
                  </td>
                  <td style={styles.cell} width="47%">
                    <p>59.56</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="21%">
                    <p>2003</p>
                  </td>
                  <td style={styles.cell} width="31%">
                    <p>36.42</p>
                  </td>
                  <td style={styles.cell} width="47%">
                    <p>63.69</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="21%">
                    <p>2009</p>
                  </td>
                  <td style={styles.cell} width="31%">
                    <p>33.9</p>
                  </td>
                  <td style={styles.cell} width="47%">
                    <p>65.7</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="21%">
                    <p>2015</p>
                  </td>
                  <td style={styles.cell} width="31%">
                    <p>23.99</p>
                  </td>
                  <td style={styles.cell} width="47%">
                    <p>76.09</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              Land uses during 1997 to 2015 is depicted in Fig. 5 and category
              wise land uses are listed in Table 5. Land use classification
              accuracy was more than 90% with kappa of 0.8 (Table 5). Temporal
              Land use dynamics showed that the urban areas have increased from
              3.66% (1997) to 19.81% (2015). Rampant Urbanization in Mumbai was
              observed since 2003, whereas in Pune during the post 2009.
              Development in the outskirts of Mumbai, Pune and Other cities such
              as Lonavala, <em>etc. </em>&nbsp;are attributed to the improved
              connectivity through the MPEW. &nbsp;
            </p>
            <p style={{ textAlign: "center" }}>
              <img
                style={{ mixBlendMode: "multiply" }}
                src="images/gv5.png"
                alt=""
              />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.5</strong> Land use dynamics
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>Table 5</strong> Land use statistics and Accuracy
              Assessment
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} rowspan="2" width="68">
                    <p>Year</p>
                  </td>
                  <td style={styles.cell} colspan="4" width="274">
                    <p>Land use Area (%)</p>
                  </td>
                  <td style={styles.cell} colspan="2" width="191">
                    <p>Classification Accuracy</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="68">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>Forest</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>Urban</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="143">
                    <p>Overall Accuracy (%)</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>Kappa</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="68">
                    <p>1997</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>7.30</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>41.27</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>3.66</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>47.77</p>
                  </td>
                  <td style={styles.cell} width="143">
                    <p>92</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>0.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="68">
                    <p>2003</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>7.12</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>36.64</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>7.04</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>49.21</p>
                  </td>
                  <td style={styles.cell} width="143">
                    <p>91</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>0.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="68">
                    <p>2009</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>7.77</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>32.33</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>11.47</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>48.42</p>
                  </td>
                  <td style={styles.cell} width="143">
                    <p>90</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>0.81</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="68">
                    <p>2015</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>7.06</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>24.64</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>19.81</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>48.5</p>
                  </td>
                  <td style={styles.cell} width="143">
                    <p>91</p>
                  </td>
                  <td style={styles.cell} width="48">
                    <p>0.85</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              Category-wise land use transitions are listed in table 6. Across
              the study area, large scale transition was observed from
              vegetation landscape to others. During 2009 and 2015, about 20% of
              the land of vegetation landscape has changed to others. Similarly,
              large scale landscape transitions were observed from others to
              built-up category (nearly 14.8%) during 2009 and 2015.
            </p>
            <p>
              <strong>Table 6</strong> Land use Transition Matrix
            </p>
            <table align="center" width="519">
              <tbody>
                <tr>
                  <td style={styles.cell} width="73">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="101">
                    <p>Transition Year</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>Vegetation</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>Built up</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>Others</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="73">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="101">
                    <p>1997 &ndash; 2003</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>93.2%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.6%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>6.3%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2003 &ndash; 2009</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>98.1%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.2%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>1.7%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2009 &ndash; 2015</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>100.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="73">
                    <p>Vegetation</p>
                  </td>
                  <td style={styles.cell} width="101">
                    <p>1997 &ndash; 2003</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.1%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>88.8%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.6%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>10.5%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2003 - 2009</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.7%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>88.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>1.2%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>10.1%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2009 - 2015</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>76.5%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>3.6%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>20.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="73">
                    <p>Built up</p>
                  </td>
                  <td style={styles.cell} width="101">
                    <p>1997 - 2003</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>100.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2003 - 2009</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>100.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2009 - 2015</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>100.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="73">
                    <p>Others</p>
                  </td>
                  <td style={styles.cell} width="101">
                    <p>1997 - 2003</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.6%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>6.5%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>93.0%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2003 - 2009</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>1.9%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>8.1%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>90.1%</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="101">
                    <p>2009 - 2015</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>0.0%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>14.8%</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>85.2%</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              Spatial patterns of urbanisation at micro levels using spatial
              metrics &nbsp;
            </p>
            <p>
              Spatial patterns of urbanisation is assessed through the
              prioritised spatial metrics (Ramachandra et al., 2012) in each
              zone along the industrial corridor and are depicted in Fig. 6.
              PLAND shows increase from 0.3% to over 1% in Zone 1 (Mumbai) and
              increase from 0.29 to over 1.58% in Zone 5 (Pune) during 1997 and
              2015 indicating an increase in percent landscape at outskirt
              regions (Zone 2, 3 and 4), which also highlight of sprawl with the
              significant urban expansions. PD shows increasing urban patches in
              the fringes of Pune and Mumbai and peri-urban areas in other
              zones, whereas the city centers showed decreasing PD indicating
              compact growth or concentrated growth. LPI showed increasing trend
              across all Zones, Mumbai and Pune showed LPI closer to 1
              indicating dominance of urban patch. The length of total edge for
              Mumbai increased till 2009 and declined by 2015 indicating that
              the entire area transforming to a single patch. Rest all patches
              shows temporal increment in total area of urban class. Spatial
              metric analysis showed compact growth in Mumbai and Pune, whereas
              fringes and other areas indicated sprawl.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv6.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.6</strong> Zone wise (along the industrial corridor)
              Spatial Statistics
            </p>
            <p>Modeling landscape dynamics though rule based models</p>
            <p>
              Urban growth models aided in simulating probable future
              situations. Models need to be based on a robust modeling strategy
              considering the high level of complexity of urban
              environments.&nbsp; Modelling of likely land use changes has been
              done through both Non- ABM (CA-Markov Chains) and ABM techniques.
              Cellular Automata (CA) was used to obtain a spatial context and
              distribution map. CA aided in simulating and predicting land use
              changes based on the transitional rules depending on the state of
              cell changes according to the neighbourhood cells and the previous
              state of the current cell with the local and regional
              interactions. CA transition rule based on land use transition is
              governed by maximum probability transition and will follow the
              constraint of cell transition that happens only once to a
              particular land use, which will never be changed further during
              simulation.
            </p>
            <p>
              The land use change patterns follow the Markovain random process
              properties with various constrains that include average&nbsp;
              transfer&nbsp; state&nbsp; of&nbsp; land&nbsp; use&nbsp;
              structure&nbsp; stable and different land use classes may
              transform to other land use class given certain condition (such as
              non-transition of urban class to water or vice versa). Thus,
              Markov was used for deriving the land use change probability map
              for the study region. CA-Markov Chains model was calibrated for
              rules such as i) vegetation changing to urban, ii) vegetation
              changing to Others category, iii) Others changing&nbsp; to urban,
              iv) urban areas remaining intact, v) water bodies remaining
              intact. Land use of known year (t3) was predicted considering the
              past land uses (t1 and t2). The variables are calibrated for kappa
              and overall accuracy. Land use data for the year 2003 and 2009 was
              used to calibrate the model and simulate land use 2015 (Fig.7).
              Validation showed that the calibrated model had an accuracy of 94%
              with Kappa of 0.85.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv7.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.7</strong> Validation of Rule based Model
            </p>
            <p>Agent Based Model</p>
            <p>
              Fuzzy Logic, Boolean Algebra, Analytical Hierarchical Process
              (AHP), Multi Criteria Evaluation (MCE) were used along with
              Cellular Automata and Markov Chains in Agent based Model. Several
              factors such as roads, industries, railways, bus stops,
              educational institution, socio-cultural places, etc. having
              positive impact on urban growth were digitized using virtual
              Google Earth data (Fig. 8). Distance maps were prepared for each
              of these factors and urban bodies were overlaid on each of the
              distance maps to estimate the range and type of influence.
              Influence range of various features area is given in Fig. 9. All
              the growth factors had a declining influence with distance on
              built-up areas whereas for other land use classes, has increasing
              influence with distance. Airports had highest influence up to
              12000m that stated declining up to 30000 m after which it has
              almost no influence on urban area. Similarly, bus stop/railways
              stations had highest influence up to 750 m which gradually reduced
              to 2000 m, Educational institutions influence was high up to 500 m
              with gradual reduction to 1500 m. Roads had influence range of 500
              to 1500 m, industries 800 to 3500 m, <em>etc.</em> Based on the
              range of influence, distance maps were normalized between 0 to 255
              using Fuzzy (Monotonically decreasing function for Built-up and
              Monotonically increasing function for others and vegetation
              class). These normalized spatial data sets were used to understand
              their influence on the landscape dynamics. Pair wise comparison
              was carried out (i.e., by comparing one driver over other
              drivers), to understand influence of a driver towards land use
              changes. Table 7 lists weightage of contributing factors of
              urbanisation.&nbsp; AHP using pair wise comparison method
              indicated that Road network had highest influence i.e., 0.309
              followed by Industries and Bus Stop with weight of 0.199, and
              educational institutes had influence of 0.156 on built-up areas
              (Table 7). Consistence ratio (measure of inconsistencies) of 0.07
              was achieved indicating that the weights obtained are precise and
              can be further used for the next process (MCE).
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv8.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.8</strong> Agents of land use changes
            </p>
            <p>
              <strong>Table 7</strong> Weightage of various contributing factors
            </p>
            <table align="center" width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Factor</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>Built up</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Road Network</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>
                      <em>0.309</em>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Industries</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>
                      <em>0.199</em>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Bus Station&nbsp; and Railway stations</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>
                      <em>0.199</em>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Educational</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>
                      <em>0.156</em>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>City Centers</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>0.072</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Airports</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>0.036</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>
                      Social (Police Station, Community halls, <em>etc</em>.)
                    </p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>0.029</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="75%">
                    <p>Consistency Ratio</p>
                  </td>
                  <td style={styles.cell} width="24%">
                    <p>0.07</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              Site suitability maps were prepared using MCE (Fig.10) for
              built-up, vegetation, and other land use classes. Site Suitability
              of built-up shows high suitability toward CBD (central business
              district), fringes and at close proximity along the MPEW. Other
              landscape shows high site suitability away from city and the
              highway, while high slope areas are less preferred for urban
              growth. Land use simulation for the year 2015 (Fig. 11) showed
              better persistency with accuracy of 96.5% and Kappa of 0.9.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv9.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.9</strong> Zone of Influence (Note: X- axis: Distance,
              Y-axis: Cumulative built up percentage)
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv10.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.10</strong> Site suitability
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv11.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.11</strong> Validation of Agent based model
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv12.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.12</strong> Land use prediction CA &ndash; Model (Non-
              ABM)
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/gv13.png" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Fig.13</strong> Land use Prediction using ABM
            </p>
            <p>Land use predictions</p>
            <p>
              Rule Based Model (Fig. 12) projected urban growth along the
              express way indicating an increase of urban area from 19.81%
              (2015) to 33.7% (2021) and 49.7% (in 2027) with decline in
              vegetation to 9.63%. Agent Based Model (Fig. 13) predicted urban
              growth increase from 19.81% (2015) to 32.16% (2021) and 47.12%
              (2027) with decline in vegetation to 11.10%. Comparative
              assessment of the model performance through accuracy assessment
              and Kappa (relatively significant at p&lt;0.05) indicates the
              superior performance of the agent based model approaches.
            </p>
            <p>
              Urban growth in Mumbai and Pune regions would reach saturation by
              2021 and the growth would spill to the peri-urban regions along
              the expressway. The regions to the SE Mumbai that is the Navi
              Mumbai and Rasayani regions are experiencing high urban growth in
              2021 and 2027 according the prediction and these regions are
              undoubtedly influenced by the metropolitan city of Mumbai. Similar
              situation toward the NW of Pune as they are facing an urban sprawl
              during 2015 and 2021 leading to a more compact growth by 2027.
              Urban growth along the Mumbai&ndash;Pune express highway also
              shows the influence of industrial and transportation corridors in
              the urban expansion. Lonavala region is experiencing high urban
              sprawl due to the influence of the expressway.
            </p>
            <p>
              Non- ABM method did predict the growth, but it overestimated the
              growth in the city and well known urban regions that are dense
              already due to the exclusion of the growth rules based on new
              planned regions and tasks (Maes, 1995). Consideration of&nbsp;
              rules and features as agents (Wooldridge and Jennings 1995)&nbsp;
              with the location specific inputs avoid overestimation of urban
              growth in the region. Navi Mumbai outskirts for example was over
              estimated by Non ABM based methods, this was corrected using agent
              growth poles as it can be seen that their also exists other
              category near the outskirts as it is reserved for non-development
              (Non- Paved). This compares the improvement over modelling using
              ABM. However, the main issues in these techniques are dependency
              on user-based data and a requirement of strong suitable database
              of all agents as described by De Smith et al. (2007). This cannot
              be used in real time modelling, as there is uncertainty in the
              agent behaviors. This can however by overcome by integrating with
              the real time urban data observatory that can provide real time
              agent behavior required for modelling.
            </p>
            <p>
              The study reveals the role of industrial corridors in land use
              transitions and future natural resource utilization. The study
              highlights that the land use dynamics due to the industrial
              corridors would not just concentrate at urban centers but would
              establish growth beyond, along the corridors, industrial pockets,
              etc. Visualising the future land use trends allows regional
              planners and managers towards the provision of appropriate
              infrastructure and basic amenities, while ensuring sustainability
              through prudent management of natural resources. &nbsp;
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
